/**
 * This function repeats the callback a given number of times, passing in the current iteration number.
 * @param times - The number of times to repeat the callback.
 * @param callback - The callback to repeat.
 * @returns An array of the results of the callback.
 * @example
 * repeat(3, (i) => i)
 * // [0, 1, 2]
 * @example
 * {repeat(steps, (i) => (
 *  <Dash active={currentStep > i} />
 * ))}
 * // [<Dash active={false} />, <Dash active={true} />, <Dash active={true} />]
 * @example
 * {repeat(steps, (i) => (
 * <Dash active={currentStep > i} />
 * ))}
 * // [<Dash active={false} />, <Dash active={true} />, <Dash active={true} />]
 **/
export const repeat = <T = unknown>(times: number, callback: (i: number) => T) =>
  Array.from({ length: times }, (_, i) => callback(i))
